import {FC, ReactNode} from "react";
import {Dialog} from "@headlessui/react";
import {AnimatePresence, motion} from "framer-motion";
import {FaTimes} from "react-icons/fa";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    title?: string | ReactNode;
}

const Modal: FC<Props> = (props) => {
    return (
        <Dialog open={props.isOpen} onClose={props.onClose}
                className='fixed z-50 inset-0 overflow-y-auto'>
            <div className="flex items-center justify-center min-h-screen">
                <Dialog.Overlay as={motion.div} initial={{opacity: 0}}
                                animate={{opacity: .5}}
                                exit={{opacity: 0}} className="fixed inset-0 bg-black"/>

                <motion.div initial={{opacity: 0, scale: .85}}
                            animate={{opacity: 1, scale: 1}}
                            exit={{opacity: 0, scale: .85}}
                            className="relative bg-white dark:bg-cardGray shadow shadow-lg rounded p-4 mx-auto w-full lg:w-1/2 xl:w-1/3">
                    <button className='absolute top-2 right-2 m-0 p-0' onClick={() => props.onClose()}>
                        <FaTimes/>
                    </button>
                    {props.title && <Dialog.Title className='text-lg font-bold mb-3'>{props.title}</Dialog.Title>}
                    <div className='text-sm'>
                        {props.children}
                    </div>
                </motion.div>
            </div>
        </Dialog>
    );
};

export default Modal;